// @flow
import React from 'react';
import Spinner from 'components/atoms/Spinner';
import './LoadingAppointment.scss';

type Props = {||};

class LoadingSelfCheckIn extends React.Component<Props> {
  static block = 'loading-appointment';
  render() {
    const ns = LoadingSelfCheckIn.block;
    return (
      <div className={ns}>
        <div className={`${ns}__wrapper`}>
          <div>
            <Spinner
              className={`${ns}__spinner`}
              classNameCircle={`${ns}__spinner--circle`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingSelfCheckIn;



// WEBPACK FOOTER //
// ./src/components/atoms/Mask/LoadingSelfCheckIn.js